<template>
  <v-card width="100%" outlined color="transparent">
    <v-card-text class="ma-0 pa-0">
      <v-select :items="monthsOptions" v-model="monthsToProlong" item-text="text" item-value="value" label="Broj meseci" required outlined hide-details></v-select>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn class="primary white--text" text @click="onClickProlong" :loading="postingToApi">
        Produži
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as apiSubscriptions from '../api/subscriptions.js';

export default {
  name: 'CompanySubscriptionProlong',
  data: function () {
    return {
      postingToApi: false,
      monthsOptions: [
        { value: 1, text: "1 mesec" },
        { value: 3, text: "3 meseca" },
        { value: 6, text: "6 meseci" },
        { value: 12, text: "12 meseci" },
      ],
      monthsToProlong: null,
    }
  },
  props: {
    companyId: {
      type: Number,
      required: true
    }
  },
  methods: {
    onClickProlong () {
      this.postingToApi = true;

      let request = {
        companyId: this.companyId,
        months: this.monthsToProlong
      }

      apiSubscriptions.startTrial(request, this.$store.getters.token)
        .then(response => response)
        .then(() => {
          // loading na dugmetu
          this.postingToApi = false;

          // prikaz snackbar obavestenja
          this.snackbarText = `Uspešno produžena pretplata za ${this.monthsToProlong} meseci`;
          this.snackbar = true;
        })
        .catch(() => {
          this.postingToApi = false;
        });
    },
  }
}
</script>
